import { formatToPercentage } from '@utils/number/formatToPercentage';
import { NO_INFORMATION_LABEL } from '@utils/text/commonText';

const safeFormatToPercentage = (
  value: unknown,
  fallbackValue: string = NO_INFORMATION_LABEL,
) => {
  if (typeof value === 'number') {
    return formatToPercentage(value);
  }

  return fallbackValue;
};

export { safeFormatToPercentage };
